import { FlexRow } from '@/components/common/Flex';
import HistoricalBalanceChange from '@/components/common/HistoricalBalanceChange';
import { toDollarsWithCents } from '@/util/currency';
import { getGoalAccountBalance } from '@common/react/goals';
import { isNumber } from '@common/util/types';
import { useBalanceChangeDateRangeState } from '../common/BalanceChange';
import {
    EntityViewContent,
    EntityViewDivider,
    entityViewInset,
} from '../common/EntityView';
import FadeInBox from '../common/FadeInBox';
import { Title } from '../common/Typography';
import GoalAccountDetailChartView from './GoalAccountDetailChartView';
import { useGoalAccountContext } from './GoalAccountDetailContainer';
import GoalAccountDetailHeader from './GoalAccountDetailHeader';
import GoalDetailLowerContentMine from './GoalDetailLowerContentMine';
import GoalDetailLowerContentTheirs from './GoalDetailLowerContentTheirs';
import GoalDetailTransactionsPillCarousel from './GoalDetailTransactionsPillCarousel';

const GoalAccountDetailView = () => {
    const { goal, goalAccount } = useGoalAccountContext();
    const goalAccountBalance = getGoalAccountBalance(goalAccount);
    const [balanceChangeDateRange, setBalanceChangeDateRange] =
        useBalanceChangeDateRangeState();

    return (
        <FadeInBox w="full" display="block">
            <GoalAccountDetailHeader goal={goal} goalAccount={goalAccount} />
            <EntityViewContent pt={0} pb={8}>
                {isNumber(goalAccountBalance) && (
                    <FlexRow
                        px={entityViewInset}
                        pb={8}
                        justifyContent="space-between"
                    >
                        <FlexRow alignItems="flex-end">
                            <Title lineHeight={1}>
                                {toDollarsWithCents(goalAccountBalance)}
                            </Title>
                            <HistoricalBalanceChange
                                dateRange={balanceChangeDateRange}
                                onChangeDateRange={setBalanceChangeDateRange}
                                positiveAccounts={[goalAccount]}
                                ml={3}
                            />
                            <GoalDetailTransactionsPillCarousel
                                goalAccount={goalAccount}
                                maxW="60%"
                            />
                        </FlexRow>
                    </FlexRow>
                )}
                <GoalAccountDetailChartView pb={8} px={entityViewInset} />
                <EntityViewDivider py={8} />
                {goalAccount.isMine && (
                    <GoalDetailLowerContentMine
                        goal={goal}
                        myGoalAccount={goalAccount}
                        filterActivitiesByGoalAccountId={goalAccount.id}
                    />
                )}
                {!goalAccount.isMine && (
                    <GoalDetailLowerContentTheirs
                        goal={goal}
                        partnerGoalAccount={goalAccount}
                        filterActivitiesByGoalAccountId={goalAccount.id}
                    />
                )}
            </EntityViewContent>
        </FadeInBox>
    );
};

export default GoalAccountDetailView;
